import {useParams} from 'react-router-dom'
import React, { useState } from 'react';

import {SVESOrderCom} from '../containers'
function SVESOrderComPage() {
    let { id } = useParams();
    let svparams = { 'id': id}
    return (
        <SVESOrderCom svparams= {svparams} />
    );
}
export default SVESOrderComPage